// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1YZT7","label":"SetPasswdForm_label__2wrv4"};